import {P} from 'components/atoms/Text/P';
import * as React from 'react';

import {FormattedMessage} from 'react-intl';
import {DisposalForm} from 'features/search/filters/enums';
import {Margin, HeadlineLevel} from 'features/ui/enums';

import {getLocalizedPrice} from 'features/services/utils/env-helper';

import './style.scss';
import {Headline} from '@atoms/Text/Headline';

interface Props {
    fee?: string | React.ReactNode;
    sharedCost?: string | React.ReactNode;
    feeTriplePlay?: boolean;
    visibleTriplePlay?: boolean;
    feeHotWater?: boolean;
    visibleHotWater?: boolean;
    feeColdWater?: boolean;
    visibleColdWater?: boolean;
    feeHeating?: boolean;
    visibleHeating?: boolean;
    sharedCostComment?: string;
    feeElectricity?: boolean;
    visibleElectricity?: boolean;
    jmnoAdditionalIndividualCosts?: string;
    jmnoIncludedInFee?: string;
    disposalForm?: string;
    jmnoShareOfDocumentFee?: number;
    jmnoDocumentFee?: number;
    jmnoPropertyRegistrationFee?: number;
    jmnoGovernmentDocumentFee?: number;
    jmnoOtherDocumentFee?: number;
    jmnoForfeitDocumentFee?: number;
    jmnoForfeitCertificateFee?: number;
    jmnoPropertyEstablishmentFee?: number;
    jmnoSharedOwnershipFee?: number;
    jmnoEstablishInFee?: number;
    jmnoOtherfee?: number;
    jmnoOtherFeeDescription?: string;
    jmnoShowOmkostningerSelveier?: boolean;
    jmnoShowOmkostningerAndel?: boolean;
}


export const FeeModal: React.FunctionComponent<Props> = ({
    fee, sharedCostComment, sharedCost,
    feeTriplePlay, visibleTriplePlay,
    feeHotWater, visibleHotWater,
    feeColdWater, visibleColdWater,
    feeHeating, visibleHeating,
    feeElectricity, visibleElectricity, jmnoIncludedInFee, jmnoAdditionalIndividualCosts, disposalForm,
    jmnoShareOfDocumentFee, jmnoDocumentFee, jmnoPropertyRegistrationFee, jmnoGovernmentDocumentFee, jmnoOtherDocumentFee, jmnoForfeitDocumentFee,
    jmnoForfeitCertificateFee, jmnoPropertyEstablishmentFee, jmnoSharedOwnershipFee, jmnoEstablishInFee, jmnoOtherfee, jmnoOtherFeeDescription,
    jmnoShowOmkostningerSelveier, jmnoShowOmkostningerAndel,
}) => {
    return (
        <div className="fee-modal">

            <Headline level={HeadlineLevel.H3} margin={Margin.L}>
                {fee &&
                    <React.Fragment><FormattedMessage id="jm.components.FeeModal.monthlyFee" /> {fee}</React.Fragment>
                }
                {sharedCost &&
                    <React.Fragment><FormattedMessage id="jm.components.FeeModal.sharedCost" /> {sharedCost}</React.Fragment>
                }
            </Headline>

            {((feeHeating && visibleHeating) || (feeHotWater && visibleHotWater) || (feeColdWater && visibleColdWater) || (feeTriplePlay && visibleTriplePlay) || (feeElectricity && visibleElectricity)) &&
                <P><strong><FormattedMessage id="jm.components.FeeModal.monthlyFeeIncludes" />:</strong>
                    {feeHotWater && visibleHotWater && <span><br />- <FormattedMessage id="jm.components.FeeModal.warmWater" /></span>}
                    {feeColdWater && visibleColdWater && <span><br />- <FormattedMessage id="jm.components.FeeModal.coldWater" /></span>}
                    {feeHeating && visibleHeating && <span><br />- <FormattedMessage id="jm.components.FeeModal.heat" /></span>}
                    {feeTriplePlay && visibleTriplePlay && <span><br />- triple play (<FormattedMessage id="jm.components.FeeModal.triplePlay" />)</span>}
                    {feeElectricity && visibleElectricity && <span><br />- <FormattedMessage id="jm.components.FeeModal.electricity" /></span>}
                </P>
            }

            {((!feeHeating && visibleHeating) || (!feeHotWater && visibleHotWater) || (!feeColdWater && visibleColdWater) || (!feeTriplePlay && visibleTriplePlay) || (!feeElectricity && visibleElectricity)) &&
                <P><strong><FormattedMessage id="jm.components.FeeModal.individualCost" />:</strong>
                    {!feeHotWater && visibleHotWater && <span><br />- <FormattedMessage id="jm.components.FeeModal.warmWater" /></span>}
                    {!feeColdWater && visibleColdWater && <span><br />- <FormattedMessage id="jm.components.FeeModal.coldWater" /></span>}
                    {!feeHeating && visibleHeating && <span><br />- <FormattedMessage id="jm.components.FeeModal.heat" /></span>}
                    {!feeTriplePlay && visibleTriplePlay && <span><br />- <FormattedMessage id="jm.components.FeeModal.triplePlay" /></span>}
                    {!feeElectricity && visibleElectricity && <span><br />- <FormattedMessage id="jm.components.FeeModal.electricity" /></span>}
                </P>
            }

            {jmnoIncludedInFee &&
                <P className="line-breaks">
                    <strong><FormattedMessage id="jm.components.FeeModal.sharedCostIncludes" />:</strong><br />
                    {jmnoIncludedInFee}
                </P>
            }

            {jmnoAdditionalIndividualCosts &&
                <P className="line-breaks">
                    <strong><FormattedMessage id="jm.components.FeeModal.additionalIndividualCosts" />:</strong><br />
                    {jmnoAdditionalIndividualCosts}
                </P>
            }

            {(jmnoIncludedInFee || jmnoAdditionalIndividualCosts) && disposalForm === DisposalForm.OWNERSHIP_APARTMENT &&
                <P><FormattedMessage id="jm.components.FeeModal.sharedCostInformationOwnershipApartment" /></P>
            }

            {(jmnoIncludedInFee || jmnoAdditionalIndividualCosts) && disposalForm === DisposalForm.CONDOMINIUM &&
                <P><FormattedMessage id="jm.components.FeeModal.sharedCostInformationCondomium" /></P>
            }

            {sharedCostComment &&
                <P>{sharedCostComment}</P>
            }

            {jmnoShowOmkostningerSelveier &&
                <P className="line-breaks">
                    <Headline level={HeadlineLevel.H3} center margin={Margin.L}><FormattedMessage id="jm.components.FeeModal.omkostningerHeadline" /></Headline>
                    <ul>
                        {jmnoDocumentFee && <li><FormattedMessage id="jm.components.FeeModal.documentFee" /> {getLocalizedPrice(jmnoDocumentFee)}<br /></li>}
                        {jmnoOtherDocumentFee && <li><FormattedMessage id="jm.components.FeeModal.otherDocumentFee" /> {getLocalizedPrice(jmnoOtherDocumentFee)}<br /></li>}
                        {jmnoForfeitDocumentFee && <li><FormattedMessage id="jm.components.FeeModal.forfeitDocumentFee" /> {getLocalizedPrice(jmnoForfeitDocumentFee)}<br /></li>}
                        {jmnoForfeitCertificateFee && <li><FormattedMessage id="jm.components.FeeModal.forfeitCertificateFee" /> {getLocalizedPrice(jmnoForfeitCertificateFee)}<br /></li>}
                        {jmnoSharedOwnershipFee && <li><FormattedMessage id="jm.components.FeeModal.sharedOwnershipFee" /> {getLocalizedPrice(jmnoSharedOwnershipFee)}<br /></li>}
                        {(jmnoOtherfee && jmnoOtherFeeDescription) && <li>{jmnoOtherFeeDescription} {getLocalizedPrice(jmnoOtherfee)}<br /></li>}
                        <br />
                        <FormattedMessage id="jm.components.FeeModal.omkostningerDisclaimer" />
                    </ul>
                </P>
            }

            {jmnoShowOmkostningerAndel &&
                <P className="line-breaks">
                    <Headline level={HeadlineLevel.H3} center margin={Margin.L}><FormattedMessage id="jm.components.FeeModal.omkostningerHeadline" /></Headline>
                    <ul>
                        {jmnoShareOfDocumentFee && <li><FormattedMessage id="jm.components.FeeModal.shareOfDocumentFee" /> {getLocalizedPrice(jmnoShareOfDocumentFee)}<br /></li>}
                        {jmnoPropertyRegistrationFee && <li><FormattedMessage id="jm.components.FeeModal.propertyRegistrationFee" /> {getLocalizedPrice(jmnoPropertyRegistrationFee)}<br /></li>}
                        {jmnoGovernmentDocumentFee && <li><FormattedMessage id="jm.components.FeeModal.governmentDocumentFee" /> {getLocalizedPrice(jmnoGovernmentDocumentFee)}<br /></li>}
                        {jmnoForfeitDocumentFee && <li><FormattedMessage id="jm.components.FeeModal.forfeitDocumentFee" /> {getLocalizedPrice(jmnoForfeitDocumentFee)}<br /></li>}
                        {jmnoForfeitCertificateFee && <li><FormattedMessage id="jm.components.FeeModal.forfeitCertificateFee" /> {getLocalizedPrice(jmnoForfeitCertificateFee)}<br /></li>}
                        {jmnoPropertyEstablishmentFee && <li><FormattedMessage id="jm.components.FeeModal.propertyEstablishmentFee" /> {getLocalizedPrice(jmnoPropertyEstablishmentFee)}<br /></li>}
                        {jmnoEstablishInFee && <li><FormattedMessage id="jm.components.FeeModal.establishInFee" /> {getLocalizedPrice(jmnoEstablishInFee)}<br /></li>}
                        {(jmnoOtherfee && jmnoOtherFeeDescription) && <li>{jmnoOtherFeeDescription} {getLocalizedPrice(jmnoOtherfee)}<br /></li>}
                        <br />
                        <FormattedMessage id="jm.components.FeeModal.omkostningerDisclaimer" />
                    </ul>
                </P>
            }
        </div>
    )
};
